/**
 * Overlap detection for transit observation windows.
 * Determines which transits have conflicting time windows with selected transits.
 */

/**
 * Build a map of overlapping transits.
 * @param {Array} transits - All transit results
 * @param {Set} selectedTransits - Set of selected transit IDs
 * @param {number} baselineBefore - Minutes of baseline before ingress
 * @param {number} baselineAfter - Minutes of baseline after egress
 * @returns {Map} Map of transitId -> { overlapsWithSelected: string[], selectedOverlapsSelected: string[] }
 */
export const computeOverlapMap = (transits, selectedTransits, baselineBefore, baselineAfter) => {
  const map = new Map();
  if (transits.length === 0 || selectedTransits.size === 0) return map;

  const windows = transits.map(transit => {
    const midpoint = new Date(transit.transit.time_utc).getTime();
    const halfDurationMs = (transit.transit.duration_hours || 0) * 3600000 / 2;
    const start = midpoint - halfDurationMs - baselineBefore * 60000;
    const end = midpoint + halfDurationMs + baselineAfter * 60000;
    const id = `${transit.exoplanet.name}_${new Date(transit.transit.time_utc).getTime()}`;
    return { id, name: transit.exoplanet.name, start, end };
  });

  const selectedWindows = windows.filter(w => selectedTransits.has(w.id));

  for (const w of windows) {
    const overlapsWithSelected = [];
    const selectedOverlapsSelected = [];
    const isSel = selectedTransits.has(w.id);

    for (const sel of selectedWindows) {
      if (sel.id === w.id) continue;
      if (w.start < sel.end && sel.start < w.end) {
        if (isSel) {
          selectedOverlapsSelected.push(sel.name);
        } else {
          overlapsWithSelected.push(sel.name);
        }
      }
    }

    if (overlapsWithSelected.length > 0 || selectedOverlapsSelected.length > 0) {
      map.set(w.id, { overlapsWithSelected, selectedOverlapsSelected });
    }
  }

  return map;
};
